export default "__VITE_ASSET__1f185c19__"